exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa {\n  vertical-align: middle; }\n\n.loaderWrapper {\n  color: lightgrey; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/shared/components/loader/loader.component.scss
// module id = ../../../../../src/app/shared/components/loader/loader.component.scss
// module chunks = main